import { Component, Input, OnInit } from '@angular/core';
import { IROPS_STATUS } from '@app/enums/irops.enum';
import { Reservation } from '@app/models/micro';
import { GlobalsService } from '@app/services/micro/globals.service';
import { getTime } from '@app/utils/functions/srIrops';

@Component({
    selector: 'itinerary-canceled-irops-rebrand',
    templateUrl: './itinerary-canceled-irops-rebrand.component.html',
    styleUrls: ['./itinerary-canceled-irops-rebrand.component.scss'],
    standalone: false
})
export class ItineraryCanceledIropsRebrandComponent implements OnInit {
  @Input() segCancel: any;
  @Input() iropsElegibility: boolean;
  segment: any;
  reservation: Reservation;
  typeIrops = IROPS_STATUS;

  constructor(private _globalsService: GlobalsService) { }

  ngOnInit() {
    this.reservation = this._globalsService.getReservation();
    this.segment = this.segCancel || {};
  }

  get changeCopyBanner() {
    if(this.reservation?.isEmployee) {
      return 'srIrops.isEmployee';
    } else if (!this.iropsElegibility) {
      return 'srIrops.goToCounterOrCall';
    } else {
      return 'srIrops.IropsBannerCancelledFlightR';
    }
  }
  
  get arrivalAirport() {
    return this.segment?.arrivalAirport;
  }

  get departureAirport() {
    return this.segment?.departureAirport;
  }

  get flightNumber() {
    let operatingCarrier;
    let operatingCode;
    
    if (this.segCancel) {
      operatingCarrier = this.segCancel?.operatingCarrier || 'AM';
      operatingCode = parseInt(this.segCancel?.operatingFlightCode || 0);
    }

    return `${operatingCarrier} ${operatingCode}`;
  }

}
